import { combinePathWithDomain } from './combinePathWithDomain';
import { getJwtToken } from './getJwtToken';
import logger from './logger';

interface FetchOptions extends Omit<RequestInit, 'body'> {
  body?: BodyInit | object | null;
}

export const fetchWithJwt = async (path: string, options: FetchOptions = {}): Promise<Response> => {
  try {
    const token = await getJwtToken();
    if (!token) {
      throw new Error('JWT token is missing');
    }

    const headers = new Headers(options.headers || {});
    console.log(typeof options.body);
    
    // Convert object body to JSON string before creating RequestInit
    let body: BodyInit | null | undefined;
    if (options.body && typeof options.body === 'object' && !(options.body instanceof FormData) && !(options.body instanceof Blob) && !ArrayBuffer.isView(options.body)) {
      logger.info('api', "adding body");// If the body is an object, convert it to a JSON string
      body = JSON.stringify(options.body);
      headers.set('Content-Type', 'application/json');
      headers.set('Accept', 'application/json');
    } else {
      body = options.body as BodyInit | null | undefined;
      if((options.method === 'POST' || options.method === 'PUT') && body){
        headers.set('Content-Type', 'application/json');
        headers.set('Accept', 'application/json');
      }
    }
    
    headers.set('Authorization', `Bearer ${token}`);
    logger.info('api', headers);

    // Destructure body from options to avoid type issues
    const { body: _, ...restOptions } = options;
    const newOptions: RequestInit = {
      ...restOptions,
      body,
      headers,
    };

    const url = combinePathWithDomain(path);
    logger.info('api', url);
    if(body) {
      logger.info('api', body);
    }

    const response = await fetch(url, newOptions);
    logger.info('api', response);

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return response;
  } catch (error) {
    logger.error('api', 'Error in fetchWithJwt:', error);
    throw error;
  }
};
